import React, { useEffect } from 'react'
import {
  Image,
  SimpleGrid,
  Button,
  Checkbox,
  Box,
  Spinner,
  VStack,
  useBoolean
} from '@chakra-ui/react'
import { useForm, Controller } from 'react-hook-form'
import { Layout } from '../../../components'
import useGadgetStore from '../../../state/Gadget.store'
import { ControlledInput, Input, Select } from '../../../components/form'

const GadgetDetails = () => {
  const [accepted, setAccepted] = useBoolean()
  const [fetchDefault, pageLoading, policies, setGadgetDetails] = useGadgetStore((state) => [
    state.fetchDefault,
    state.loading,
    state.policies,
    state.setGadgetDetails
  ])

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    watch,
    control
  } = useForm({
    mode: 'onChange',
    defaultValues: { category: '', brand: '', model: '', price: '', period: '' }
  })
  const onSubmit = async (data: any) => {
    try {
      await fetchDefault(data.price)
      setGadgetDetails(data)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Layout title="Gadget Details">
      <>
        <Box id="my-form" flex={1} as="form" onSubmit={handleSubmit(onSubmit)}>
          <Image mx="auto" mb="3.2rem" h="207px" src="/images/loading.svg" />

          <Select
            isValid={watch('category') && touchedFields.category && !errors.category && true}
            isError={touchedFields.category && errors.category && errors.category.message}
            label="Gadget Category"
            id="category"
            value={watch('category')}
            formHook={register('category', {
              required: 'Gadget Category is required'
            })}
            options={[{ label: 'Smartphone', value: 'Smartphone' }]}
          />

          <SimpleGrid columns={2} spacing="1.6rem">
            <Select
              isValid={watch('brand') && touchedFields.brand && !errors.brand && true}
              isError={touchedFields.brand && errors.brand && errors.brand.message}
              label="Gadget Brand"
              id="brand"
              value={watch('brand')}
              formHook={register('brand', {
                required: 'Gadget Brand is required'
              })}
              options={[
                { label: 'Samsung', value: 'Samsung' },
                { label: 'iPhone', value: 'iPhone' }
              ]}
            />

            <Input
              isValid={watch('model') && touchedFields.model && !errors.model && true}
              isError={touchedFields.model && errors.model && errors.model.message}
              label="Model"
              id="model"
              value={watch('model')}
              formHook={register('model', {
                required: 'Model is required'
              })}
            />
          </SimpleGrid>

          <Controller
            control={control}
            rules={{
              required: 'Cost Price is required',
              min: { value: 1, message: 'Cost Price is required' }
            }}
            name="price"
            render={({ field }) => (
              <ControlledInput
                isValid={watch('price') && !errors.price && true}
                isError={errors.price && errors.price.message}
                label="Cost Price"
                id="price"
                inputMode="numeric"
                type="text"
                value={field.value}
                onChange={(e) => {
                  e.target.value = (
                    parseInt(e.target.value.replace(/[^\d]+/gi, ''), 10) || 0
                  ).toLocaleString('en-US')
                  field.onChange(e)
                }}
              />
            )}
          />
        </Box>
        <Checkbox onChange={setAccepted.toggle} mt="6rem" size="lg">
          I acknowledge that the information displayed above is accurate and up-to-date at this time
        </Checkbox>
        <Button
          isLoading={pageLoading}
          disabled={!accepted}
          mt="2.4rem"
          form="my-form"
          type="submit"
          variant="blue">
          Submit
        </Button>
      </>
    </Layout>
  )
}

export { GadgetDetails }
